import { render, staticRenderFns } from "./Contacts-item.vue?vue&type=template&id=d47b8b5c&"
import script from "./Contacts-item.vue?vue&type=script&lang=js&"
export * from "./Contacts-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports